module.exports = __webpack_public_path__ + "img/cases-2.22da53dc.png";